import { types } from 'mobx-state-tree';
const model = {
    name: types.string,
    score: types.number,
    trend: types.model({
        value: types.maybeNull(types.number),
        direction: types.string,
    }),
};
const CompanyTopicModel = types.model(model);
export default CompanyTopicModel;
